import AxiosInstance from './config/Http'
import Config from './config/Constants'
import { fetchAllPages } from './config/Pagination'

// Obtiene todas las órdenes de mantenimiento
export const getMaintenances = async () => {
  try {
    const response = await fetchAllPages<any>(`${Config.core.maintenances}`, {
      sort: 'idMaintenance,desc',
    })
    return { status: true, json: response.data }
  } catch (error: any) {
    console.error("Error in getMaintenances", error)
    return {
      status: false,
      message:
        "Hubo un error al obtener órdenes de trabajo, intente luego. " +
        (error.response?.status || ""),
    }
  }
}
